<script lang="ts">
  // Экспорт свойств компонента
  export let toggleVPN: () => void;
  export let isBlind: boolean;
</script>

<section class="hero">
  <div class="container">
    <div class="hero-content">
      <div class="eye-spacer"></div>
      
      <h1 class="hero-title">Сделайте Око <span class="highlight">{isBlind ? "слепым" : "невидимым"}</span></h1>
      
      <p class="hero-description">
        BlindEye VPN защищает вашу конфиденциальность, делая невидимым ваше присутствие в сети. 
        Никаких логов, отслеживания и вмешательства - только свобода передвижения по всему миру виртуального Средиземья.
      </p>
      
      <div class="toggle-container">
        <span class="toggle-label {!isBlind ? 'active' : ''}">Око видит всё</span>
        <label class="switch">
          <input type="checkbox" checked={isBlind} on:change={toggleVPN} />
          <span class="slider"></span>
        </label>
        <span class="toggle-label {isBlind ? 'active' : ''}">Око ослеплено</span>
      </div>
      
      <div class="hero-cta">
        <a href="#pricing" class="btn {isBlind ? 'btn-shire' : 'btn-primary'}">Выбрать тариф</a>
        <a href="#download" class="btn btn-outline">Скачать приложение</a>
      </div>
      
      <div class="hero-stats">
        <div class="stat-item">
          <span class="stat-value">200+</span>
          <span class="stat-label">Серверов</span>
        </div>
        <div class="stat-item">
          <span class="stat-value">35+</span>
          <span class="stat-label">Стран</span>
        </div>
        <div class="stat-item">
          <span class="stat-value">10</span>
          <span class="stat-label">Устройств</span>
        </div>
      </div>
    </div>
  </div>
</section>

<style>
  .hero {
    min-height: 90vh;
    display: flex;
    align-items: center;
    padding: 4rem 0;
    position: relative;
    overflow: hidden;
  }
  
  .hero-content {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    z-index: 1;
  }
  
  .eye-spacer {
    height: 250px;
    margin-bottom: 3rem;
  }
  
  .hero-title {
    font-size: 3.5rem;
    margin-bottom: 1.5rem;
    font-weight: 900;
    line-height: 1.2;
    margin-top: 3rem;
  }
  
  .highlight {
    background: linear-gradient(45deg, var(--sauron-red), var(--sauron-yellow));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .hero-description {
    font-size: 1.25rem;
    margin-bottom: 2.5rem;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.6;
  }
  
  .toggle-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 2.5rem;
  }
  
  .toggle-label {
    font-weight: 600;
    opacity: 0.7;
    transition: opacity 0.3s ease;
  }
  
  .toggle-label.active {
    opacity: 1;
    text-shadow: 0 0 10px var(--sauron-red);
  }
  
  :global(body.shire-mode) .toggle-label.active {
    text-shadow: 0 0 10px var(--shire-green);
  }
  
  .switch {
    position: relative;
    display: inline-block;
    width: 70px;
    height: 38px;
  }
  
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--mordor-dark);
    border: 2px solid var(--sauron-red);
    transition: 0.4s;
    border-radius: 34px;
    box-shadow: 0 0 10px rgba(255, 69, 0, 0.5);
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 30px;
    width: 30px;
    left: 4px;
    bottom: 2px;
    background: radial-gradient(circle at center, var(--sauron-yellow) 0%, var(--sauron-red) 70%);
    transition: 0.4s;
    border-radius: 50%;
    box-shadow: 0 0 5px rgba(255, 69, 0, 0.8);
  }
  
  input:checked + .slider {
    background-color: var(--shire-light);
    border-color: var(--shire-green);
    box-shadow: 0 0 10px rgba(34, 139, 34, 0.5);
  }
  
  input:checked + .slider:before {
    transform: translateX(32px);
    background: radial-gradient(circle at center, white 0%, var(--shire-green) 70%);
    box-shadow: 0 0 5px rgba(34, 139, 34, 0.8);
  }
  
  .hero-cta {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-bottom: 3rem;
  }
  
  .btn-outline {
    border: 2px solid currentColor;
    background-color: transparent;
    color: inherit;
    padding: 0.75rem 1.5rem;
    border-radius: 0.375rem;
    font-weight: 600;
    transition: all 0.3s ease;
    display: inline-block;
    text-decoration: none;
  }
  
  .btn-outline:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  .hero-stats {
    display: flex;
    justify-content: center;
    gap: 3rem;
  }
  
  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .stat-value {
    font-size: 2.5rem;
    font-weight: 900;
    font-family: 'Cinzel', serif;
    background: linear-gradient(45deg, var(--sauron-red), var(--sauron-yellow));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  :global(body.shire-mode) .stat-value {
    background: linear-gradient(45deg, var(--shire-green), var(--shire-light));
    -webkit-background-clip: text;
    background-clip: text;
  }
  
  .stat-label {
    font-weight: 500;
    opacity: 0.8;
  }
  
  @media (max-width: 768px) {
    .hero-title {
      font-size: 2.5rem;
    }
    
    .eye-spacer {
      height: 200px;
    }
    
    .hero-stats {
      flex-direction: column;
      gap: 1.5rem;
    }
    
    .hero-cta {
      flex-direction: column;
      align-items: center;
    }
  }
</style> 